export function initRoleCards() {
    document.addEventListener("click", (e) => {
        const infoBtn = e.target.closest(".flex-role-cards__info-btn");
        if (infoBtn) {
            const card = infoBtn.closest(".flex-role-cards__card");
            if (!card) return;
            openOverlay(card, infoBtn);
            return;
        }

        const closeBtn = e.target.closest(".flex-role-cards__close-btn");
        if (closeBtn) {
            const card = closeBtn.closest(".flex-role-cards__card");
            if (!card) return;
            closeOverlay(card);
            return;
        }
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            const openCard = document.querySelector(
                ".flex-role-cards__card.is-overlay-open"
            );
            if (openCard) {
                closeOverlay(openCard);
            }
        }
    });
}

function openOverlay(card, trigger) {
    card.classList.add("is-overlay-open");
    const overlay = card.querySelector(".flex-role-cards__overlay");
    if (overlay) overlay.setAttribute("aria-hidden", "false");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
}

function closeOverlay(card) {
    card.classList.remove("is-overlay-open");
    const overlay = card.querySelector(".flex-role-cards__overlay");
    if (overlay) overlay.setAttribute("aria-hidden", "true");
    const trigger = card.querySelector(".flex-role-cards__info-btn");
    if (trigger) {
        trigger.setAttribute("aria-expanded", "false");
        trigger.focus();
    }
}
